<script lang="ts">
import {Vue, Component} from 'vue-facing-decorator';
import NavBar from "@/component/common/NavBar.vue";
import HomeLabComponent from "@/component/project/HomeLabComponent.vue";

@Component({
  components: {HomeLabComponent, NavBar}
})
export default class HomeLabView extends Vue {
}
</script>

<template>
  <NavBar/>
  <div class="view-container">
    <HomeLabComponent/>
  </div>
</template>

<style scoped>
.view-container {
  min-height: calc(100vh - var(--ln-nav-offset));
  padding: 3rem 2rem;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

@media (max-width: 768px) {
  .view-container {
    padding: 1rem;
  }
}
</style>
